
const toggleButtons = document.querySelectorAll("[data-toggle-display]");

// Event listeners to buttons
toggleButtons.forEach((element, index, elements) => {
    element.addEventListener('click', function(){
        const toggleAreaId = this.getAttribute("aria-controls");
        const toggleArea = document.getElementById(toggleAreaId);

        this.classList.toggle("open");
        toggleArea.classList.toggle("open");

        const isExpanded = toggleArea.getAttribute("aria-expanded") === "true";

        if (isExpanded) {
            // Close the toggled area
            this.setAttribute("aria-expanded", "false");
            toggleArea.setAttribute("aria-hidden", "true");
        } else {
            // Open the toggled area
            this.setAttribute("aria-expanded", "true");
            toggleArea.setAttribute("aria-hidden", "false");
        }
    });
});

